"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { knowledgeAgent } from "@/content/agent-use-cases/knowledge-agent";

export default function KnowledgeAgentUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={knowledgeAgent} locale={locale} />;
}
